
import { useLanguage } from "@/contexts/LanguageContext";
import StepContainer from "../components/StepContainer";
import DeviceSection from "../components/DeviceSection";
import { Location } from "../types";
import { useStepValidation } from "../hooks/useStepValidation";
import { ReactNode } from "react";

interface LocationsStepProps {
  selectedLocations?: Location[];
  onDeviceSelect: (devices: number) => void;
  onLocationsChange: (locations: Location[]) => void;
  onNext: () => void;
  onBack: () => void;
  aiAssistantButton?: ReactNode;
}

const LocationsStep = ({ 
  selectedLocations = [],
  onDeviceSelect, 
  onLocationsChange,
  onNext,
  onBack,
  aiAssistantButton
}: LocationsStepProps) => {
  const { t } = useLanguage();
  const { isLocationStepValid } = useStepValidation();

  // Real-time validation
  const isNextDisabled = !isLocationStepValid(selectedLocations);

  return (
    <StepContainer
      title={t("locations")}
      description={t("selectLocationDesc")}
      onNext={onNext}
      onBack={onBack}
      isNextDisabled={isNextDisabled}
      aiAssistantButton={aiAssistantButton}
    >
      <DeviceSection 
        selectedLocations={selectedLocations}
        onDeviceSelect={onDeviceSelect} 
        onLocationsChange={onLocationsChange} 
      />
    </StepContainer>
  );
};

export default LocationsStep;
